<template>
  <div class="panel-item">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>{{titleTime}}</div>
    </div>
    <div ref="chartContainer" style="width: 100%; height: calc(100% - 45px);"></div>
  </div>
</template>

<script>
import {tFormatDate} from '@/utils/utils';
import * as echarts from 'echarts';

export default {
  props: {
    titleTime: {
      type: String,
      default: '产品分类'
    },
    category_sales_pie_block: {
      type: Object,
    },
    select_no: {
      type: Array,
      default: ()=>[]
    },
    showLabel:{
      type: Boolean,
      default: true
    },
    legendPage:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  watch: {
    // 监听 category_sales_pie_block 数据变化
    category_sales_pie_block: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.updateChart();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initChart() {
      // 初始化图表
      this.chart = echarts.init(this.$refs.chartContainer);

      // 设置初始空图表配置
      const option = {
        series: [{
          type: 'pie',
          radius: ['20%', '50%'],
          center: ['30%', '50%'],
          data: []
        }]
      };

      this.chart.setOption(option);

      // 监听窗口大小变化，自适应图表
      window.addEventListener('resize', this.handleResize);
    },

    updateChart() {
      if (!this.chart || !this.category_sales_pie_block) return;

      // 处理数据格式
      const pieData = this.category_sales_pie_block.pie_data.map(m => {
        return {
          name: m.cate_name,
          value: m.count_product_value
        };
      });

      // 计算总数
      const total = this.category_sales_pie_block.total_count_product

      // 创建图例选中状态对象，默认"其他"不选中
      const legendSelected = {};
      pieData.forEach(item => {
        if (this.select_no.includes(item.name)) {
          legendSelected[item.name] = false;
        } else {
          legendSelected[item.name] = true;
        }
      });

      // 更新图表配置
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          position: function (point, params, dom, rect, size) {
            // 计算 tooltip 的位置，确保不会超出左侧边界
            const x = point[0] < size.viewSize[0] / 2 ? point[0] + 10 : point[0] - dom.offsetWidth - 10;
            const y = point[1] < size.viewSize[1] / 2 ? point[1] + 10 : point[1] - dom.offsetHeight - 10;
            return [x, y];
          }
        },
        legend: {
          orient: 'vertical',
          right: '20',
          top: 'center',
          textStyle: {
            color: '#FFFFFF',
            fontSize: 12,  // 增大字体大小
            overflow: 'truncate', // 如果 ECharts 版本支持
            width: 120 // 固定宽度
          },
          width: 'auto',
          height: this.legendPage?'70%':'200', // 控制总体高度以容纳两列各10项
          itemWidth: 6,
          itemHeight: 12,
          itemGap: 8,
          formatter: function (name) {
            return name
          },
          selected: legendSelected, // 设置图例默认选中状态
          type: this.legendPage?'scroll':'',
          pageIconColor: '#FFFFFF',  // 翻页按钮颜色
          pageIconInactiveColor: '#808080',  // 翻页按钮不激活颜色
          pageTextStyle: {
            color: '#FFFFFF'
          },
        },
        series: [
          {
            name: '产品分类',
            type: 'pie',
            radius: ['30%', '60%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              formatter: this.showLabel? [
                '{title|产品分类(个)}',
                `{subtitle|总计: ${total}}`
              ].join('\n'):'',
              rich: {
                title: {
                  color: '#00A8FF',
                  fontSize: 14,
                  fontWeight: 'bold',
                  lineHeight: 24
                },
                subtitle: {
                  color: '#CCCCCC',
                  fontSize: 16,
                  lineHeight: 20
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: pieData
          }
        ],
      };

      // 使用 setOption 更新图表
      this.chart.setOption(option, true);
    },

    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  .title_name {
    padding: 30px 0 0px 100px;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
  }
}
</style>
